/* eslint-env browser */
import { GET_VACANCIES } from './const';

export default (element) => {
  if (window.DYCON && window.DYCON.EmplyData) {
    const data = DYCON.EmplyData[element];
    return {
      type: GET_VACANCIES,
      payload: {
        data,
      },
    };
  }
  return null;
};
